import './home.css';
import { useState, useContext } from 'react';
import { UserContext } from '../context/UserContext';
import { Link } from 'react-router-dom';

export default function Kontakt() {
  const { user } = useContext(UserContext);
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [subject, setSubject] = useState('');
  const [message, setMessage] = useState('');
  const [consent, setConsent] = useState(false);
  const [error, setError] = useState('');

  function isValidEmail(v) {
    return /.+@.+\..+/.test(v || '');
  }

  function buildMailTo() {
    const to = 'kontakt@ap-n.de';
    const subj = subject?.trim() || '';
    const bodyLines = [
      name?.trim() ? `Name: ${name.trim()}` : 'Name: -',
      `E-Mail: ${email.trim()}`,
      '',
      'Nachricht:',
      message?.trim() || '-',
      '',
      '---',
      'Gesendet über das AP-N Webportal (Kontaktformular)'
    ];
    const body = bodyLines.join('\n');
    const url = `mailto:${to}?subject=${encodeURIComponent(subj)}&body=${encodeURIComponent(body)}`;
    return url;
  }

  function createEmail(e) {
    if (e) e.preventDefault();
    setError('');
    if (!isValidEmail(email)) {
      setError('Bitte gib eine gültige E‑Mail-Adresse an.');
      return;
    }
    if (!subject.trim()) {
      setError('Bitte gib einen Betreff ein.');
      return;
    }
    if (!message.trim()) {
      setError('Bitte gib eine Nachricht ein.');
      return;
    }
    if (!consent) {
      setError('Bitte stimme der Verarbeitung deiner Angaben zu.');
      return;
    }
    // Öffnet den Standard‑Mailclient
    window.location.href = buildMailTo();
  }

  return (
    <div className="home-page">
      {/* Hero */}
      <section id="top" className={user ? 'hero-offset-if-sidebar' : ''} style={{ width:'100vw', margin:0, padding:0 }}>
        <h2 className="hero-title" style={{ textAlign: 'center', margin:'0 0 8px' }}>Kontakt</h2>
        <p className="hero-desc" style={{ margin:'0 auto 24px', textAlign: 'center', maxWidth:760 }}>Wir freuen uns auf deine Nachricht.</p>
      </section>

      <section style={{ width: '100%', maxWidth: 900, margin: '0 auto', padding: '0 16px 40px 16px', color: '#fff' }}>
        <div className="creators-events-grid">
          {/* Info */}
          <div className="highlight-card" style={{ padding: 24 }}>
            <h2 className="highlight-title" style={{ marginTop: 0 }}>So erreichst du uns</h2>
            <p className="highlight-desc">Schicke uns eine Mail an:</p>
            <p className="highlight-desc" style={{ marginTop: 6 }}>
              E‑Mail: <a href="mailto:kontakt@ap-n.de" style={{ color: '#32CD89' }}>kontakt@ap-n.de</a>,
              <br/>oder nutze das nebenstehende Formular.
            </p>
            <div style={{ marginTop: 12 }}>
              <a className="hero-btn-secondary" href="mailto:kontakt@ap-n.de">Direkt per E‑Mail</a>
            </div>
            <p className="highlight-desc" style={{ marginTop: 8, opacity: .9 }}>
              Hinweis: Es wird dein Standard‑Mailclient geöffnet. Alternativ kannst du uns direkt anschreiben.
            </p>
          </div>

          {/* Formular */}
          <div className="highlight-card" style={{ padding: 24 }}>
            <h2 className="highlight-title" style={{ marginTop: 0 }}>Kontaktformular</h2>
            <p className="highlight-desc" style={{ marginTop: 4 }}>Deine Nachricht wird lokal in deinem Mailprogramm geöffnet.</p>

            <form onSubmit={createEmail}>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12 }}>
                <div style={{ gridColumn: '1 / -1' }}>
                  <label className="highlight-desc" htmlFor="name">Dein Name (optional)</label>
                  <input id="name" type="text" value={name} onChange={e=>setName(e.target.value)} placeholder="Max Mustermann" style={{ width: '100%', padding: '10px 12px', marginTop: 6, borderRadius: 8, border: '1px solid #333', background: '#0c0c0c', color: '#fff' }} />
                </div>
                <div>
                  <label className="highlight-desc" htmlFor="email">Deine E‑Mail*</label>
                  <input id="email" type="email" value={email} onChange={e=>setEmail(e.target.value)} placeholder="du@beispiel.de" style={{ width: '100%', padding: '10px 12px', marginTop: 6, borderRadius: 8, border: '1px solid #333', background: '#0c0c0c', color: '#fff' }} />
                </div>
                <div>
                  <label className="highlight-desc" htmlFor="subject">Betreff*</label>
                  <input id="subject" type="text" value={subject} onChange={e=>setSubject(e.target.value)} placeholder="Kurzer Betreff" style={{ width: '100%', padding: '10px 12px', marginTop: 6, borderRadius: 8, border: '1px solid #333', background: '#0c0c0c', color: '#fff' }} />
                </div>
                <div style={{ gridColumn: '1 / -1' }}>
                  <label className="highlight-desc" htmlFor="message">Nachricht*</label>
                  <textarea id="message" value={message} onChange={e=>setMessage(e.target.value)} placeholder="Worum geht es?" rows={6} style={{ width: '100%', padding: '10px 12px', marginTop: 6, borderRadius: 8, border: '1px solid #333', background: '#0c0c0c', color: '#fff', resize: 'vertical' }} />
                </div>
              </div>

              <label style={{ display: 'flex', alignItems: 'center', gap: 10, marginTop: 10 }}>
                <input type="checkbox" checked={consent} onChange={e=>setConsent(e.target.checked)} />
                <span>
                  Ich stimme der Verarbeitung meiner Angaben zur Beantwortung der Anfrage zu. Hinweise: {' '}
                  <Link to="/datenschutz" style={{ color:'#32CD89', textDecoration:'underline' }}>Datenschutz</Link>.
                </span>
              </label>

              {error && <div style={{ color: '#ff9aa2', marginTop: 10 }}>{error}</div>}

              <div style={{ display: 'flex', gap: 8, marginTop: 14, flexWrap: 'wrap', justifyContent: 'center' }}>
                <span>
                  <button type="submit" className="hero-btn-primary">E‑Mail erstellen</button>
                </span>
              </div>

              <div className="highlight-desc" style={{ marginTop: 8, opacity: .9 }}>
                Hinweis: Es wird dein Standard‑Mailclient geöffnet. Alternativ kannst du uns direkt anschreiben.
              </div>
            </form>
          </div>
        </div>

        {/* Weitere Hinweise */}
        <div className="highlight-card" style={{ padding: 24, marginTop: 16 }}>
          <h2 className="highlight-title" style={{ marginTop: 0 }}>Weitere Hinweise</h2>
          <ul className="highlight-desc" style={{ marginTop: 6, listStyle: 'none', paddingLeft: 0 }}>
            <li style={{ display: 'flex', alignItems: 'flex-start', gap: 8 }}>
              <span aria-hidden="true" style={{ color: '#32CD89', marginTop: 2 }}>✔</span>
              <span>Bitte keine sensiblen Daten über das Formular senden.</span>
            </li>
            <li style={{ display: 'flex', alignItems: 'flex-start', gap: 8 }}>
              <span aria-hidden="true" style={{ color: '#32CD89', marginTop: 2 }}>✔</span>
              <span>Antwortzeiten können variieren, wir melden uns so schnell wie möglich.</span>
            </li>
          </ul>
        </div>
      </section>
    </div>
  );
}
